
import { defineComponent } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// constants
import { HTTP_ERROR_MESSAGE } from '@/core/constants/http.constants'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        text: {
            type: String,
            default: null,
        },
        errorMessage: {
            type: String,
            default: null,
        },
        errorStatus: {
            type: Number,
            default: null,
        },
        errorUrl: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['refresh'],
    setup(_, { emit }) {
        const emitRefresh = () => {
            emit('refresh')
        }

        return { emitRefresh, HTTP_ERROR_MESSAGE }
    },
})
